export const GET_INVESTOR_KPI_REQUEST =
  'user.investor.dashboard.kpi.GET_INVESTOR_KPI_REQUEST'
export const GET_INVESTOR_KPI_SUCCESS =
  'user.investor.dashboard.kpi.GET_INVESTOR_KPI_SUCCESS'
export const GET_INVESTOR_KPI_FAILURE =
  'user.investor.dashboard.kpi.GET_INVESTOR_KPI_FAILURE'
export const STORE_DATES = 'user.investor.dashboard.kpi.STORE_DATES'
